import { makeStyles } from '@material-ui/styles'

import Theme from '@refera/ui-core'

export default makeStyles(({ spacing, palette }) => ({
  // General
  label: {
    fontSize: spacing(14),
    color: Theme.Colors.Grayscale.Eighty,
  },
  required: {
    color: Theme.Colors.Red.Base,
    marginLeft: spacing(4),
  },
  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(8),
    width: '100%',
  },

  // Compartment fields
  compartmentContainer: {
    width: '25%',
    marginTop: spacing(18),
  },

  // Problem fields
  problemContainer: {
    width: '100%',
    marginTop: spacing(18),
  },

  // Warranty Months fields
  warrantyField: {
    width: '150px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    flexShrink: 0,
  },
  warrantyText: {
    position: 'absolute',
    left: '32px',
    bottom: '24px',
  },

  // Mandatory Service fields
  radioWrapper: {
    marginTop: '4px',
  },
  radioGroup: {
    display: 'flex !important',
    flexDirection: 'row !important',
    gap: '16px !important',

    '@media (max-width: 1364px)': {
      flexDirection: 'column !important',
      gap: '2px !important',
    },
  },
  radioClasses: {
    width: 'auto !important',
    border: 'none !important',
    padding: '0px !important',
    fontWeight: 'normal !important',

    '& .MuiTypography-root': {
      fontSize: '12px !important',
    },
  },
  descriptionLabel: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tooltipIcon: {
    fontSize: '2rem',
    fontWeight: '500',
    lineHeight: '2.4rem',
    fill: palette.gray[64],
    margin: 0,
  },
}))
